<template>
    <div>
      <base-navigation></base-navigation>
   
    <div class="container">
      <h4 id="head" style="font-weight: bold;"> {{ campaignDetaills[0].name  }} </h4>
      <p id="message" class="message">{{ campaignDetaills[0].message}}.  Make payments to Roberms collection paybill 4112827, Account {{ campaignDetaills[0].paybill_account }}#YourNames(As you want to appear in collection list)</p>

      <!-- id{{ campaign_id }} -->
       <!-- details {{  campaignDetaills }} -->
      <br>
      <br>
      <div class="table-container">
        <table>
          <tbody>
            <tr v-for="(item, index) in collections" :key="item.id">
              <!-- `${index + 1}. ${item.display_names} - ${this.formatCurrency(item.transAmount)}` -->
              <td>{{ index + 1 }} </td>
             
              <td>{{ item.display_names }}</td>
              <td>{{ formatCurrency(item.TransAmount) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="total-container">
        <br>
        List autopopulates after paying
        <br> 
        <strong>Total: {{ formatCurrency(totalAmount) }}</strong>
      </div>
      <button @click="copyTableData" class="copy-button">Copy Data</button>
      <br>
      <shuffle-winner></shuffle-winner>
    </div>
  </div>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  // import createPersistedState from 'vuex-persistedstate';
  
  export default {
    
    name: "CollectionsTable",
  data() {
    return {
      campaign_id: this.extractCampaignId(),
      message: document.getElementById('message'),
    };
  },
    // plugins: [createPersistedState()], // Add this line

    computed: {
      ...mapGetters(["collections"]),
      totalAmount() {
        return this.collections.reduce(
          (total, item) => total + item.TransAmount,
          0
        );
      },
      collections() {
        return  this.$store.getters.collections.filter(code=>code.clinet_code ==this.campaign_id).filter(pr=>pr.processed !=1 )
       
      },
      campaignDetaills() {
        return  this.$store.getters.allCampaigns.filter(code=>code.paybill_account ==this.campaign_id)
       
      },
    //   campaignD()
    //   {
    //     return  this.$store.getters.allCampaigns.filter(code=>code.paybill_account ==this.campaign)

    //   },

    },
  //    beforeMount() {
  //   // Check if the sessionStorage is empty
  //   if (!sessionStorage.getItem("isVisited")) {
  //     // Mark that the user visited this page
  //     sessionStorage.setItem("isVisited", "true");
  //   } else {
  //     // Redirect only on refresh (if "isVisited" exists)
  //     this.$router.push("/dashboard");
  //   }
  // },
  // beforeMount() {
  //   // Check if user exists in localStorage on page refresh
  //   const storedUser = localStorage.getItem("user");

  //   if (storedUser) {
  //     try {
  //       // Parse the user data if it's valid JSON
  //       this.user = JSON.parse(storedUser);
  //     } catch (error) {
  //       console.error("Error parsing user from localStorage:", error);
  //       // Clear invalid data if necessary
  //       localStorage.removeItem("user");
  //     }
  //   } else {
  //     // Handle the case where no user is found
  //     console.log("No user found in localStorage.");
  //   }
  // },
  // beforeMount() {

  //   console.log('Page reload detected. Fetching data...', this.account);
  //   this.$store.dispatch('LoadCollections');
  // },
    methods: {
      extractCampaignId() {
      const segments = this.$route.path.split('/');
      return segments[segments.length - 1]; // Get the last segment of the URL
    },

      formatCurrency(amount) {
        return new Intl.NumberFormat("en-KE", {
          style: "currency",
          currency: "KES",
          minimumFractionDigits: 0,
        }).format(amount);
      },
      
      
      copyTableData() {
        // const campaignHead = document.getElementById('head').textContent;
        const campaignName = document.getElementById('message').textContent;
        const rows = [
          // [campaignHead],
          // [" "],
      [campaignName],
      [" "], // Only a small space to separate message and data
      ...this.collections.map((item, index) => [
        `${index + 1}. ${item.display_names} - ${item.TransAmount}` // No currency here
      ]),
      [`*Total: ${this.formatCurrency(this.totalAmount)}*`], // Bold total with asterisk for WhatsApp
    ];
  
    const tableText = rows.map((row) => row.join("   ")).join("\n"); // Added minimal spacing and line breaks
    navigator.clipboard
          .writeText(tableText)
          .then(() => {
            alert(" data copied to clipboard!");
          })
          .catch((err) => {
            console.error("Failed to copy table data: ", err);
          });
      },
    },
  //   watch: {
  //   // Watch for route changes
  //   $route() {
  //     this.campaign_id = this.extractCampaignId();
  //   },
  // },
    created() {
      // if (!this.$store.state.campaigns || this.$store.state.collections.campaigns === 0) {
      //   this.$store.dispatch('LoadCollections'); 
      //     }
      // const getLastItem = thePath=>thePath.substring(thePath.lastIndexOf('/')+1)
      // console.log(getLastItem(this.$route))
      this.$store.dispatch('LoadCollections');  
      this.$store.dispatch('LoadCampaigns'); 
     this.campaign= this.$route.params.account
      
      
    },
    
  };
  </script>
  
  <style scoped>
  .container {
    max-width: 600px;
    margin: 20px auto;
    padding: 15px;
    font-family: Arial, sans-serif;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    background-color: #fff;
  }
  
  h2 {
    text-align: center;
    color: #007bff;
    font-size: 1.8rem;
  }
  
  .message {
    margin-bottom: 15px;
    padding: 10px;
    background-color: #f8f9fa;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 1rem;
    text-align: center;
  }
  
  .table-container {
    overflow-x: auto;
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
    text-align: center;
  }
  
  td {
    padding: 12px;
    text-align: center;
    border: 1px solid #ddd;
    font-size: 0.9rem;
  }
  
  tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  tr:hover {
    background-color: #f1f1f1;
  }
  
  .total-container {
    margin-top: 15px;
    text-align: center;
    font-size: 1.2rem;
    font-weight: bold;
  }
  
  .copy-button {
    display: block;
    width: 100%;
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 1rem;
  }
  
  .copy-button:hover {
    background-color: #0056b3;
  }
  
  /* Responsive Design */
  @media (max-width: 600px) {
    h2 {
      font-size: 1.5rem;
    }
    .message {
      font-size: 0.9rem;
    }
    table td {
      font-size: 0.8rem;
    }
    .copy-button {
      font-size: 0.9rem;
    }
  }
  </style>
  
